import React from "react";
import NavigationTokens from "../../constants/navigationTokens";
import { IDelivery } from "../../interfaces/IDelivery";
import DateService from "../../utilities/dateService";
import "./notifications.scss";
import OrderImage from "./orderImage";

const noImageSrc = "http://images.wbmason.com/240/nia-240.jpg";

export interface IWhereIsMyStuffProps {
  delivery: IDelivery;
  index: number;
  navTokens: Record<string, string>;
}

function WhereIsMyStuff(props: IWhereIsMyStuffProps) {
  let trackingDetails = null; // populated by getDateTimeStatus()
  const getDateTimeStatus = () => {
    if (props.delivery.isThirdPartyDelivery) {
      if (props.delivery.deliveryInfo.trackingDetails) {
        let latestDate = null;
        let trackingUrl = null;
        let trackingNumber = null;
        for (
          let i = 0;
          i < props.delivery.deliveryInfo.trackingDetails.length;
          i++
        ) {
          const detail = props.delivery.deliveryInfo.trackingDetails[i];

          const detailDate = DateService.parse(detail.trackingDateTime);

          if (!latestDate || detailDate.getTime() > latestDate.getTime()) {
            latestDate = detailDate;
            trackingNumber = detail.trackingNumber;
            trackingUrl = detail.trackingLinkBaseUrl + trackingNumber;
          }
        }

        if (latestDate) {
          trackingDetails = (
            <>
              {trackingUrl && trackingNumber && (
                <a
                  className="notification-go-to"
                  href={trackingUrl}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  {trackingNumber}
                </a>
              )}
            </>
          );
          return <b>{DateService.toMonthDateYearString(latestDate)}</b>;
        }
      }
    }

    if (
      (props.delivery.isThirdPartyDelivery || props.delivery.isToBeDelivered) &&
      props.delivery.order &&
      props.delivery.order.date
    ) {
      const date = DateService.parse(props.delivery.order.date);
      return (
        <b>
          <b>Submitted</b> {DateService.toMonthDateYearString(date)}
        </b>
      );
    }

    if (props.delivery.isDelivered) {
      return (
        <span className="where-is-my-stuff-success-text font-weight-bold">
          {DateService.toMonthDateYearTimeEstString(
            DateService.parse(props.delivery.deliveryInfo.deliveryDate)
          )}
        </span>
      );
    }

    return <span></span>;
  };

  const orderIdHref =
    props.navTokens[NavigationTokens.OrderHistoryDetails] +
    `?SID=${props.delivery.orderId}`;

  const deliveryStatusInfo = props.delivery.deliveryInfo.internalDeliveryInfo
    ? props.delivery.deliveryInfo.internalDeliveryInfo.deliveryStatusInfo
    : props.delivery.deliveryInfo.deliveryStatusInfo;

  const orderLines = (deliveryStatusInfo as Record<string, any[]>).orderLines;

  const dateTimeStatus = getDateTimeStatus();

  return (
    <div className="where-is-my-stuff-order container pt-2" key={props.index}>
      <div className="row">
        <div className="col-7">
          {/*comment out for now !props.delivery.order.viewed && <NotificationIcon />*/}
          <b
            className={
              props.delivery.isDelivered ? "where-is-my-stuff-success-text" : ""
            }
          >
            {(deliveryStatusInfo as Record<string, string>).headerText}
          </b>
        </div>
        <div className="col-5 text-right where-is-my-stuff-order-id">
          <div>
            <span>Order #</span> <b>{props.delivery.orderId}</b>
          </div>
          {trackingDetails}
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-12 where-is-my-stuff-status">{dateTimeStatus}</div>
      </div>
      <div className="row">
        <div className="col-12 wms-product-images">
          <OrderImage orderLine={orderLines[0]} defaultSrc={noImageSrc} />
          {orderLines.length > 1 && (
            <OrderImage orderLine={orderLines[1]} defaultSrc={noImageSrc} />
          )}
          {orderLines.length > 2 && (
            <OrderImage orderLine={orderLines[2]} defaultSrc={noImageSrc} />
          )}
          {orderLines.length > 3 && (
            <a href={orderIdHref} className="where-is-my-stuff-x-more">
              + <b>{orderLines.length - 3}</b> More
            </a>
          )}
        </div>
      </div>
      <div className="notification-divider pt-2"></div>
    </div>
  );
}

export default WhereIsMyStuff;
